class World extends Array {}

const world_api_adapter = world => {
    return world;
};

const world_api_list_adapter = world => world.map(world_api_adapter);

const createWorldList = (data = []) => {
    const world = World.from(data, world => createWorld(world));
    return world;
};

const world_view_adapter = world => {
    return world;
};

const createWorld = ({id = null, name = null, geom = null} = {}) => {
    const publicApi = {
        id,
        name,
        geom,
    };

    return Object.freeze(publicApi);
};

export {
    createWorld,
    createWorldList,
    world_api_adapter,
    world_api_list_adapter,
    world_view_adapter,
};
